import '../react/Component/index.jsx'

document.addEventListener('DOMContentLoaded', () => {
	//
})